<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="large" color="#fff" type="ball-clip-rotate-multiple"
    [fullScreen]="true">
    <p style="color: white">{{setLabel("pleaseWaitLabel")}}</p>
</ngx-spinner>

<p-toast position="top-right"></p-toast>

<div class="card card-w-title p-steps-tecfolk-fix mobile-padding-0 signup-res" style="text-align: center">
    <p-steps [model]="items" [(activeIndex)]="activeIndex" [readonly]="true"></p-steps>

    <div class="card card-w-title mobile-padding-0" *ngIf="activeIndex == 0">
        <div class="p-g-12">
            <input pinputtext="" style="width: 35% !important; text-align:
                center" (keyup)="searchLocal(package.packageName, 'name',$event);" [placeholder]='setLabel("searchByPackageNamePlaceholderLabel")'
                type="text" #packageName autocomplete="off" name="name" [(ngModel)]="package.packageName"
                class="p-inputtext p-corner-all p-state-default p-widget"  />
        </div>

        <div class="p-g-12 p-md-6 p-lg-4 task-list package-card-tecfolk-fix" style="display: flex;" *ngFor="let package of
            packages let i=index">
            <p-panel class="widthFull" header="{{ package.packageName }} ({{i+1}})" [style]="{backgroundColor: package.color }">
                <div style="flex-grow: 1; display: flex; flex-direction: column; align-items: center; justify-content: center; height: 200px;">
                    <img src="assets/demo/gymLogo/{{ package.logo }}.png" style="height: 48px" />
                    <div class="p-panel-content p-widget-content">
                        <ul class="signupMembershipCard pl-0">
                            <li>
                                {{setLabel("rsLabel")}} <b>{{ package.packageFee | number:'1.0-0'}}</b>
                            </li>
                            <li>
                                <div *ngIf="package.noOfMonths !== 0">
                                   {{setLabel("receresForLabel")}} {{ package.noOfMonths }} {{setLabel("monthLabel")}}
                                </div>
                                <div *ngIf="package.noOfWeeks !== 0 ">
                                   {{setLabel("receresForLabel")}} {{ package.noOfWeeks }} Week(s)
                                </div>
                                <div *ngIf="package.noOfDays !== 0 ">
                                   {{setLabel("receresForLabel")}} {{ package.noOfDays }} Day(s)
                                </div>
                            </li>
                            <span *ngIf="package.registerationFee> 0">
                                <li>
                                    ({{setLabel("admisssionFeeRsLabel")}}<b>{{ package.registerationFee | number:'1.0-0' }} {{setLabel("pKRLabel")}}</b>)
                                </li>
                            </span>
                            <span *ngIf="package.ageGroupFrom">
                                <li>
                                    (For Age Group Between <b>{{ package.ageGroupFrom }} & {{package.ageGroupTo}}</b>)
                                </li>
                            </span>
                            <span *ngIf="package.description">
                                <li>{{ package.description }} !</li>
                            </span>
                            <!-- <li style="margin-top: 50px"> -->
                                <!-- <button id="loginbtn" [disabled]="loading" (click)="selectSubcription(package, 'NO')" class="p-button
                                    p-widget
                                    p-state-default
                                    p-corner-all">
                                    <span class="p-button-text p-c">Next</span>
                                    <span *ngIf="loading" class="p-button-icon-left
                                        p-c
                                        fa fa-spinner fa-spin" style="font-size:
                                        24px"></span>
                                </button> -->

                                <!-- <input type="button" id="loginbtn" [disabled]="loading" (click)="selectSubcription(package, 'NO')" class="p-button
                                p-widget
                                p-state-default
                                p-corner-all" value="Next"/> -->

                            <!-- </li> -->
                        </ul>
                    </div>
                </div>
                <div style="flex-grow: 0;">
                    <input type="button" id="loginbtn" [disabled]="loading" (click)="selectSubcription(package, 'NO')" class="p-button
                    p-widget
                    p-state-default
                    p-corner-all" value="Next"/>
                </div>

            </p-panel>
        </div>
        <div style="clear: both"></div>
    </div>
    <div *ngIf="noOfMembers===1">
        <div class="card card-w-title mobile-padding-0" *ngIf="activeIndex == 1">
            <app-add-single-signup [subPackage]="subPackage" (changeWizard)="changeWizard()"
                (feeData)="feeUpdate($event)"></app-add-single-signup>
        </div>
    </div>
    <div *ngIf="noOfMembers > 1">
        <div class="card card-w-title mobile-padding-0" *ngIf="activeIndex == 1">
            <app-add-multiple-signup [subPackage]="subPackage" (changeWizard)="changeWizard()"
                (feeData)="feeUpdate($event)"></app-add-multiple-signup>
        </div>
    </div>

    <div class="card card-w-title mobile-padding-0" style="text-align: left !important" *ngIf="activeIndex == 2">
        <app-fee-collect [members]="members" (feeCollection)="feeCollection()"></app-fee-collect>
    </div>
    <div class="card card-w-title mobile-padding-0" style="text-align: left !important" *ngIf="activeIndex == 3">
        <!-- Montly Fee -->
        <div class="p-g send-fee-receipt-res">
            <div class="p-g-12">
                <div style="padding: 0px !important; margin: auto !important">
                    <p-table [value]="members" [paginator]="true" [rows]="10" [loading]="loading" class="p-table-tecfolk-fix">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>{{setLabel("membershipNoLabel")}}</th>
                                <th>{{setLabel("nameLabel")}}</th>
                                <th>{{setLabel("dueDateLabel")}}</th>
                                <th>{{setLabel("monthlyFeeLabel")}}</th>
                                <th>{{setLabel("monthlyDiscountLabel")}}</th>
                                <th>{{setLabel("registrationFeeLabel")}}</th>
                                <th>{{setLabel("registrationDiscountLabel")}}</th>
                                <th>{{setLabel("mobileLabel")}}</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-memberFees>
                            <tr>
                                <td>
                                    <div class="mobile-label">{{setLabel("membershipNoLabel")}}</div>
                                    <div>{{ memberFees.tagNumber }}</div>
                                </td>
                                <td>
                                    <div class="mobile-label">{{setLabel("nameLabel")}}</div>
                                    <div>{{ memberFees.name }}</div>
                                </td>
                                <td>
                                    <div class="mobile-label">{{setLabel("dueDateLabel")}}</div>
                                    <div>{{memberFees.joiningDate| date: "dd/MM/yyyy"}}</div>

                                </td>
                                <td>
                                    <div class="mobile-label">{{setLabel("monthlyFeeLabel")}}</div>
                                    <div>{{ memberFees.monthFee }}</div>
                                </td>
                                <td>
                                    <div class="mobile-label">{{setLabel("monthlyDiscountLabel")}}</div>
                                    <div>{{monthlyDiscount }}</div>
                                </td>
                                <td>
                                    <div class="mobile-label">{{setLabel("registrationFeeLabel")}}</div>
                                    <div>{{ memberFees.registerationFee }}</div>
                                </td>
                                <td>
                                    <div class="mobile-label">{{setLabel("registrationDiscountLabel")}}</div>
                                    <div>{{ registrationDiscount }}</div>
                                </td>
                                <td>
                                    <div class="mobile-label">{{setLabel("mobileLabel")}}</div>
                                    <div>{{ memberFees.contactDetail.contact }}</div>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>
        </div>

        <br />
        <div style="text-align-last: center">
            <button style="background: #008CBA; color: white;" id="printButton" (keydown)="toPrintInvoice($event)" #printButton class="p-button p-widget p-state-default p-corner-all">
                <span class="p-button-text p-c"  (click)="printInvoice()"><i class="fa fa-print"
                        aria-hidden="true"></i>&nbsp;&nbsp;{{setLabel("printLabel")}}</span>
            </button>
            &nbsp;&nbsp;

            <!-- *ngIf="members.length === 1 && members[0].email" -->
            <!-- <button  id="sendReceiptButton" style="background: #4CAF50; color:white;margin-top: 10px;"
                (click)="openEmailConfirmation()"
                class="p-button p-widget p-state-default p-corner-all p-button-text-only"><i class="fa fa-at"
                    aria-hidden="true"></i>&nbsp; {{setLabel("sendReceiptLabel")}}</button>
            &nbsp;&nbsp; -->

            <button style="background: #e7e7e7; color:black;" (keydown)="toFinish($event)" id="finishButton" class="p-button p-widget p-state-default p-corner-all">
                <span class="p-button-text p-c" (click)="finish()"><i class="fa fa-check"
                        aria-hidden="true"></i>&nbsp;&nbsp;{{setLabel("finishLabel")}} </span>
            </button>
        </div>
        <div style="clear: both"></div>
    </div>

    <!-- <div *ngIf="dialogVisibility">
        <p-dialog header="Capture Photo" [closeOnEscape]="true" [(visible)]="dialogVisibility">
            <app-camera (pictureTaken)="handleImage($event)"></app-camera>
        </p-dialog>
    </div> -->
    <div *ngIf="dialogVisibility" class="tecfolkProfileDialogFix">
        <!-- <p-dialog header="Add Profile Photo" [(visible)]="dialogVisibility">
            <app-add-profile-image [popupType]="addProfileImage" (closeThePopup)="hideAddProfileImage()" (outputImage)="handleImagefromNewProfile($event)"></app-add-profile-image>
        </p-dialog> -->
        <!-- popupType : Upload | Cam -->
    </div>
</div>



<!-- Invoice Print -->
<app-receipt-print [company]="company" [branch]="branch" [email]="email" [printInvoiceMembers]="printInvoiceMembers" (sendingBackhtmlToPdf)="sendingBackhtmlToPdf($event)" (closeEmailConfirmation)="closeEmailConfirmation()" [members]="members" [fundInvoice]="fundInvoice" [subPackage]="subPackage"
    [totalReceivedFee]="totalReceivedFee"  [totalPackageFee]="totalPackageFee" [registrationDiscount]="registrationDiscount" [monthlyDiscount]="monthlyDiscount" [trainerDiscount]="trainerDiscount"
    [noofMonths]="noofMonths" [noOfMembers]="noOfMembers"  [totalTrainerFee]="totalTrainerFee" [totalRegistrationPackageFee]="totalRegistrationPackageFee" [taxRate]="taxRate" [taxType]="taxType"></app-receipt-print>

<div *ngIf="feeInvoiceDialog" class="fees-invoice-res">
    <app-feeCollection-signup [totalPackageFee]="totalPackageFee" [totalReceivedFee]="totalReceivedFee" [noofMonths]="noofMonths" [durationType]="durationType" [packageFeeType]="packageFeeType"
    [packageRegFeeType]="packageRegFeeType" [noOfMembers]="noOfMembers" [packageName]="packageName" [packageType]="packageType"
        (closeFeeCollectionDialog)="closeFeeCollectionDialog()" [totalTrainerFee]="totalTrainerFee"
        [totalRegistrationPackageFee]="totalRegistrationPackageFee" [feeInvoiceDialog]="feeInvoiceDialog"    [joiningDate]="dateOfJoining"
        [member_id]="member_id"  [onlineMembers]="onlineMembers"
        (addFund)="addFund($event)">
    </app-feeCollection-signup>
</div>

<!--  -->
<div id="ID-card" style="display: none" class="p-g-12">
    <div class="ID-card">
        <div class="top-row">
            <img class="flag" [src]="company.bannerImage == null
                ? 'assets/layout/images/logoCompany.png'
                : company.bannerImage" alt="national flag" style="width: 73px; height: 39px" />
            <h4 class="card-title">
                {{ company.name }},
                <small>{{
                    company.address == null ? "" : company.address
                    }}</small>
            </h4>
        </div>
        <div class="middle-row" style="width: 100%; text-align: left;
            margin-top: -18px">
            <p class="name-title">{{setLabel("membershipNumber:Label")}} <span
                    style="font-weight: bold !important;">{{member.tagNumber}}</span></p>
            <p class="name-title">{{setLabel("name:Label")}} <span style="font-weight: bold !important;">{{member.name}}</span> </p>
            <p class="name-title">{{setLabel("gender:Label")}} <span style="font-weight: bold !important;">{{member.gender}}</span></p>
            <p class="name-title">{{setLabel("joiningDate:Label")}} <span style="font-weight: bold !important;">{{member.joiningDate | date:
                    'dd/MM/yyyy'}}</span></p>
            <p class="name-title">{{setLabel("mobile:Label")}} <span
                    style="font-weight: bold !important;">{{member.contactDetail.contact}}</span>
            </p>
        </div>
        <div class="ID-photo" style="display: block;
                    width: 100px;
                    height: 128px;
                    background-repeat: no-repeat;
                    background-position: -90px center;
                    background-size: 250px;
                    position: absolute;
                    top: 82px !important;
                    right: 28px !important;">
            <img style="width: 100%; margin-top: 25px; height: 105px" [src]="member.profile == null
                ? 'assets/layout/images/avatarImg.png'
                : member.profile" />
        </div>
        <h5 class="series-number">V {{ member._id }}</h5>
        <h5 class="signature-title" style="bottom: 11px !important; right: 24px !important;">{{setLabel("holderSignatureLabel")}}</h5>
    </div>
    <br />
    <div class="ID-card">
        <div class="top-row" style="padding: 30px 0 !important">
            <!-- <img [src]="company[0].bannerImage == null ? 'assets/layout/images/tec-company-logo.png' : config.Server + company[0].bannerImage" style="width: 100%;height: 60px;margin-left: 18px;"/> -->
            <img class="flag" [src]=" (company.bannerImage ? config.Server + 'assets/layout/images/companies/' + company.bannerImage : 'assets/layout/images/logoCompany.png')" alt="Company Logo"
                style="margin-left: 35% !important; height: 60px" />
        </div>
        <div class="middle-row" style="width: 100%; text-align: left;
            margin-top: -20px">
            <h4 class="card-title" style="text-align: center !important">
                {{setLabel("cell:Label")}} {{ company.phone }}<br />
                {{ company.address == null ? "" : company.address }}
            </h4>
        </div>
        <div class="logoDiv" style="text-align: center !important;">
            {{setLabel("poweredByLabel")}} &nbsp;
            <a href="http://tecfolk.com/" target="_blank"><img style="width:
                    66px" src="http://tecfolk.com/Content/img/tecfolk-logo-trasprantNormal.png" alt="" /></a>
        </div>
        <p style="text-align: center;font-size: 12px;">{{setLabel("Phone:Label")}} {{powerByNumber}}.</p>
    </div>
</div>

<p-dialog [(visible)]="showEmailReceiptConfirmationBox" [closeOnEscape]="true" [focusOnShow]="false" [style]="{width: '54vw', left:'10px', top:'23px'}">
    <ng-template pTemplate="header">
        {{setLabel("sendReceiptLabel")}}
    </ng-template>
    <form #emailConfirmationForm="ngForm">
        <div style="display: flex; flex-direction: column;">
            <!-- <h3 class="first" style="font-weight: 400;">To</h3> -->
            <div class="p-g-12" style="padding-bottom: 20px;">
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon" [pTooltip]='setLabel("sendToTooltipLabel")' tooltipPosition="top"><i class="fa fa-user" aria-hidden="true"></i></span>
                    <input autocomplete="off" [(ngModel)]="email.to"
                        pattern="^([a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+,*[\W]*)+$" type="text" pInputText
                        [placeholder]='setLabel("toPlaceholderLabel")' name="to" required />

                </div>
            </div>
            <!-- <h3 class="first" style="font-weight: 400;">Subject</h3> -->
            <div class="p-g-12" style="padding-bottom: 20px;">
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon" [pTooltip]='setLabel("subjectTooltipLabel")' tooltipPosition="top"><i class="fa fa-envelope" aria-hidden="true"></i></span>
                    <input autocomplete="off" [(ngModel)]="email.subject" type="text" pInputText [placeholder]='setLabel("subjectPlaceholderLabel")'
                        name="subject" required />
                </div>
            </div>
            <!-- <h3 class="first" style="font-weight: 400;">Body</h3> -->
            <div class="p-g-12  ck-editor_bodyScroll">
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon" [pTooltip]='setLabel("bodyTooltipLabel")' tooltipPosition="top"><i class="fa fa-pencil-square-o"
                            aria-hidden="true"></i></span>
                    <!-- <ckeditor name="ckeditor" style="width: 100%; -webkit-box-sizing: border-box; -moz-box-sizing: border-box; box-sizing: border-box;" [editor]="Editor" (change)="onBodyChange($event)">
                    </ckeditor> -->
                    <!-- <p-editor [(ngModel)]="email.body" name="body" [style]="{'height':'320px'}"></p-editor> -->
                    <ckeditor name="ckeditor" style="
            width: 100%;
            -webkit-box-sizing: border-box;
            -moz-box-sizing: border-box;
            box-sizing: border-box;
        " [editor]="Editor" [(ngModel)]="email.body"></ckeditor>
                </div>
            </div>
            <!-- <div class="p-g-12">
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon"><i class="fa fa-pencil-square-o" aria-hidden="true"></i></span>
                    <textarea class="textarea" rows="5" cols="80" style="width: 100%; -webkit-box-sizing: border-box; -moz-box-sizing: border-box; box-sizing: border-box;"
                    [(ngModel)]="email.body" placeholder="Body" name="body" pInputTextarea></textarea>
                </div>
            </div> -->
        </div>
        <p-footer>
            <div  class="email-button-registration">
                <button style="background: #e7e7e7; color:black;" (click)="closeEmailConfirmation()"
                    class="p-button p-widget p-state-default p-corner-all p-button-text-only">Cancel</button>
                <button [disabled]="!emailConfirmationForm.valid" style="background: #4CAF50; color:white;" (click)="sendInvoiceEmailAsPdf()"
                    class="p-button p-widget p-state-default p-corner-all p-button-text-only">Send</button>
            </div>
        </p-footer>
    </form>
</p-dialog>